import {
  EuiFlexGroup,
  EuiFlexItem,
  EuiFieldSearch,
  EuiButtonGroup,
} from "@inscopix/ideas-eui";
import { useProjectTablesTableContext } from "components/ProjectTablesTable/provider/ProjectTablesTableProvider";
import { useMemo } from "react";
import { TABLE_ICONS } from "types/Icons";

/*
 * Shows a search bar and toggle for filtering tables
 * Allows for:
 * - Filtering on name/key
 * - Toggling table types (analysis and data)
 */
export const ProjectTablesSearchAndFilter = () => {
  const searchValue = useProjectTablesTableContext((s) => s.searchValue);
  const onSearchChange = useProjectTablesTableContext((s) => s.onSearchChange);
  const showHidden = useProjectTablesTableContext((s) => s.showHidden);
  const setShowHidden = useProjectTablesTableContext((s) => s.setShowHidden);
  const tableFilter = useProjectTablesTableContext((s) => s.tableFilter);
  const onChangeTableTypeFilter = useProjectTablesTableContext(
    (s) => s.onChangeTableTypeFilter,
  );
  // avoiding heavy EuiIcon rerenders
  const filterTypeButtons = useMemo(() => {
    const filterTableTypeOptions = [
      {
        id: "data" as const,
        label: "Show data tables only",
        iconType: TABLE_ICONS["data"],
      },
      {
        id: "analysis" as const,
        label: "Show analysis tables only",
        iconType: TABLE_ICONS["analysis"],
      },
      {
        id: "workflow" as const,
        label: "Show workflow tables only",
        iconType: TABLE_ICONS["workflow"],
      },
      {
        id: "showHidden" as const,
        label: "Show/hide hidden tables",
        iconType: "eyeClosed",
      },
    ];
    return (
      <EuiButtonGroup
        type="multi"
        legend="Filter by type"
        options={filterTableTypeOptions}
        idToSelectedMap={{
          data: tableFilter === "data",
          analysis: tableFilter === "analysis",
          workflow: tableFilter === "workflow",
          showHidden,
        }}
        onChange={(_id) => {
          const id = _id as (typeof filterTableTypeOptions)[number]["id"];
          switch (id) {
            case "data":
            case "workflow":
            case "analysis":
              onChangeTableTypeFilter(id);
              break;
            case "showHidden":
              setShowHidden(!showHidden);
              break;
          }
        }}
        isIconOnly
      />
    );
  }, [onChangeTableTypeFilter, setShowHidden, showHidden, tableFilter]);

  return (
    <EuiFlexGroup gutterSize="m" alignItems="center" responsive={false}>
      <EuiFlexItem>
        <EuiFieldSearch
          fullWidth
          placeholder="Search tables..."
          value={searchValue}
          onChange={(e) => onSearchChange(e)}
          isClearable={true}
        />
      </EuiFlexItem>
      <EuiFlexItem grow={false}>{filterTypeButtons}</EuiFlexItem>
    </EuiFlexGroup>
  );
};
